
import { localizedStrings as mobileLinesLocalizedStrings } from './mobileLines';
import { localizedStrings as activateMobileLineLocalizedStrings } from './activateMobileLine';
import { localizedStrings as xboxGamePassLocalizedStrings } from './xboxGamePass';
import { localizedStrings as activateXboxGamePassBonusLocalizedStrings } from './activateXboxGamePassBonus';
import { localizedStrings as internetLocalizedStrings } from './internet';
import { localizedStrings as devicesLocalizedStrings } from './devices';
import { localizedStrings as r2rLocalizedStrings } from './r2r';
import { localizedStrings as packLocalizedString } from './pack';
import { localizedStrings as tvLocalizedString } from './tv';
import { localizedStrings as fttrLocalizedString } from './fttr';
import { localizedStrings as subscriptionsLocalizedStrings } from './subscriptions';
import { localizedStrings as bonusLocalizedString } from './bonus';
import { localizedStrings as equipmentLocalizedString } from './equipment';
import { localizedStrings as manualLocalizedString } from './manual';
import { localizedStrings as employeesLocalizedString } from './employees';
import { localizedStrings as protectionLocalizedString } from './protection';
import { localizedStrings as prepaidLocalizedString } from './prepaid';
import { localizedStrings as multiSimLocalizedString } from './multiSim';
import { localizedStrings as carLocalizedString } from './car';
import { localizedStrings as eSimLocalizedString } from './eSim';
import { localizedStrings as r2rRenewalLocalizedString } from './r2rRenewal';
import { localizedStrings as changeOTTModalityLocalizedString } from './changeOTTModality';
import { localizedStrings as duoRenewalLocalizedString } from './duo';
import { localizedStrings as billinLocalizedString } from './billin';
import { localizedStrings as speedChangeLocalizedString } from './speedChange';
import { localizedStrings as r2rAutoRenewalLocalizedString } from './r2rAutoRenewal';
import { localizedStrings as packR2RLocalizedString } from './packR2R';
import { localizedStrings as movistarPlusLocalizedString } from './movistarPlus';
import { FLOW_TYPES } from '../../flowDefinition/flowTypes';


export const localizedStrings = {
  [FLOW_TYPES.MOBILE_LINES]: mobileLinesLocalizedStrings,
  [FLOW_TYPES.ACTIVATE_MOBILE_LINE]: activateMobileLineLocalizedStrings,
  [FLOW_TYPES.XBOX_GAME_PASS]: xboxGamePassLocalizedStrings,
  [FLOW_TYPES.ACTIVATE_XBOX_GAME_PASS_BONUS]: activateXboxGamePassBonusLocalizedStrings,
  [FLOW_TYPES.INTERNET]: internetLocalizedStrings,
  [FLOW_TYPES.DEVICES]: devicesLocalizedStrings,
  [FLOW_TYPES.R2R]: r2rLocalizedStrings,
  [FLOW_TYPES.R2R_2]: r2rLocalizedStrings,
  [FLOW_TYPES.PACK]: packLocalizedString,
  [FLOW_TYPES.TV]: tvLocalizedString,
  [FLOW_TYPES.FTTR]: fttrLocalizedString,
  [FLOW_TYPES.SUBSCRIPTIONS]: subscriptionsLocalizedStrings,
  [FLOW_TYPES.BONUS]: bonusLocalizedString,
  [FLOW_TYPES.EQUIPMENT]: equipmentLocalizedString,
  [FLOW_TYPES.MANUAL]: manualLocalizedString,
  [FLOW_TYPES.EMPLOYEES]: employeesLocalizedString,
  [FLOW_TYPES.PROTECTION]: protectionLocalizedString,
  [FLOW_TYPES.PREPAID]: prepaidLocalizedString,
  [FLOW_TYPES.MULTI_SIM]: multiSimLocalizedString,
  [FLOW_TYPES.CAR]: carLocalizedString,
  [FLOW_TYPES.E_SIM]: eSimLocalizedString,
  [FLOW_TYPES.R2R_RENEWAL]: r2rRenewalLocalizedString,
  [FLOW_TYPES.CHANGE_OTT_MODALITY]: changeOTTModalityLocalizedString,
  [FLOW_TYPES.DUO]: duoRenewalLocalizedString,
  [FLOW_TYPES.BILLIN]: billinLocalizedString,
  [FLOW_TYPES.SPEED_CHANGE]: speedChangeLocalizedString,
  [FLOW_TYPES.R2R_AUTO_RENEWAL]: r2rAutoRenewalLocalizedString,
  [FLOW_TYPES.PACK_R2R]: packR2RLocalizedString,
  [FLOW_TYPES.MOVISTAR_PLUS]: movistarPlusLocalizedString,
};
